import type { IconProps } from '@hedepy/icons/Icon'
import type { ComponentType, ReactNode } from 'react'

import { Text } from '@/src/domains/design-system/components/Text'

export interface TherapistFilterMenuLabelUIProps {
  Icon: ComponentType<IconProps>
  children: ReactNode
}

export const TherapistFilterMenuLabelUI = ({ Icon, children }: TherapistFilterMenuLabelUIProps) => (
  <Text element="h3" weight="bold" className="mb-0">
    <Icon size={24} aria-hidden className="mr-3 inline-block text-peach-500" />
    {children}
  </Text>
)
